import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Button } from '@tarja/ui';
import { useEffect, useId, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { ETIQUETA_PERFIL, navegacionPara, perfiles, type ItemNav } from '../auth/capacidades';

function SelectorTenant() {
  const { usuario, tenantActivo, cambiarTenant } = useAuth();
  const id = useId();
  const [cambiando, setCambiando] = useState(false);
  if (!usuario || usuario.tenants.length < 2) return null;
  return (
    <div className="w-tenant">
      <label htmlFor={id} className="t-sr-only">
        Organización activa
      </label>
      <select
        id={id}
        className="t-select"
        value={tenantActivo ?? ''}
        disabled={cambiando}
        onChange={async (e) => {
          setCambiando(true);
          try {
            await cambiarTenant(e.target.value);
          } finally {
            setCambiando(false);
          }
        }}
      >
        {usuario.tenants.map((t) => (
          <option key={t.tenant_id} value={t.tenant_id}>
            {t.nombre}
          </option>
        ))}
      </select>
    </div>
  );
}

export function Layout() {
  const { usuario, caps, logout, marca } = useAuth();
  const [menuAbierto, setMenuAbierto] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => setMenuAbierto(false), [pathname]);
  const items = navegacionPara(caps);
  const grupos = items.reduce<Record<string, ItemNav[]>>((acc, i) => {
    (acc[i.grupo] ??= []).push(i);
    return acc;
  }, {});
  const rol = usuario ? perfiles(usuario).map((p) => ETIQUETA_PERFIL[p]).join(' · ') : '';

  return (
    <div className="w-app">
      <a href="#contenido" className="t-skip">
        Saltar al contenido
      </a>
      <header className="w-cabecera">
        <div className="w-cabecera__izq">
          <Button
            variante="fantasma"
            className="w-menu-btn"
            aria-expanded={menuAbierto}
            aria-controls="navegacion"
            onClick={() => setMenuAbierto((v) => !v)}
          >
            ☰ <span className="t-sr-only">Menú</span>
          </Button>
          {marca.logo_url ? <img src={marca.logo_url} alt="" className="w-logo" /> : null}
          <span className="w-marca">{marca.nombre_producto ?? 'Tarja'}</span>
        </div>
        <div className="w-cabecera__der">
          <SelectorTenant />
          <div className="w-usuario">
            <span className="w-usuario__nombre">{usuario?.nombre}</span>
            {rol ? <span className="w-usuario__rol">{rol}</span> : null}
          </div>
          <Link to="/mi-cuenta" className="w-usuario__cuenta">
            Mi cuenta
          </Link>
          <Button chico onClick={() => void logout()}>
            Salir
          </Button>
        </div>
      </header>
      <div className="w-cuerpo">
        <nav id="navegacion" className={`w-nav${menuAbierto ? ' w-nav--abierto' : ''}`} aria-label="Principal">
          {Object.entries(grupos).map(([grupo, lista]) => (
            <div key={grupo} className="w-nav__grupo">
              <h2 className="w-nav__titulo">{grupo}</h2>
              <ul>
                {lista.map((i) => (
                  <li key={i.ruta}>
                    <Link to={i.ruta} className="w-nav__link" activeProps={{ className: 'w-nav__link w-nav__link--activo', 'aria-current': 'page' }} activeOptions={{ exact: i.ruta === '/' }}>
                      {i.etiqueta}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <main id="contenido" className="w-main" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
      {marca.pie_legal ? <footer className="w-pie">{marca.pie_legal}</footer> : null}
    </div>
  );
}
